import Basketball from "@/components/Basketball.vue";
import { loadMapsLibrary, loadMarkerLibrary } from "@/lib/google/mapsLoader";
import { h, onBeforeUnmount, Ref, ref, render, watch } from "vue";

export default function (
  container: Ref<HTMLElement | null>,
  coordinates: Ref<{
    latitude: number,
    longitude: number,
  } | null>,
) {
  const isReady = ref(false);

  let map: google.maps.Map | null = null;
  let marker: google.maps.marker.AdvancedMarkerElement | null = null;
  let markerContent: HTMLElement | null = null;

  watch([container, coordinates], async ([element, coordinates]) => {
    if (!element || !coordinates || map) return;

    const [
      {
        Map,
      },
      {
        AdvancedMarkerElement,
      },
    ] = await Promise.all([loadMapsLibrary(), loadMarkerLibrary()]);

    const center = {
      lat: coordinates.latitude,
      lng: coordinates.longitude,
    };

    map = new Map(element, {
      center,
      zoom: 15,
      mapId: import.meta.env.VITE_GOOGLE_MAPS_MAP_ID,
      disableDefaultUI: true,
      gestureHandling: "greedy",
      clickableIcons: false,
      keyboardShortcuts: false,
      renderingType: "VECTOR",
    });

    markerContent = createBasketballMarker();

    marker = new AdvancedMarkerElement({
      map,
      position: center,
      content: markerContent,
    });

    google.maps.event.addListenerOnce(map, "tilesloaded", () => {
      isReady.value = true;
    });
  });

  onBeforeUnmount(() => {
    if (marker) marker.map = null;
    if (markerContent) render(null, markerContent);

    map = null;
    marker = null;
    markerContent = null;
  });

  return {
    isReady,
  };
}

function createBasketballMarker () {
  const element = document.createElement("div");
  element.className = "GoogleMapMarker";
  element.style.display = "flex";
  element.style.transform = "translateY(50%) scale(0.75)";
  render(h(Basketball), element);

  return element;
}
